
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.5 3a3 3 0 01-2.25 2.905v7.631c1.294.125 2.25.566 2.25 1.089 0 .621-1.342 1.125-3 1.125s-3-.504-3-1.125c0-.525.956-.964 2.25-1.089v-7.63A3 3 0 1115.5 3z"}}),_c('path',{attrs:{"d":"M.5 14.497v2.576a1.5 1.5 0 00.83 1.34l9.829 4.916a3 3 0 002.682 0l9.83-4.915a1.5 1.5 0 00.829-1.341v-2.576c0-.15-.09-.285-.228-.345l-9.522-4.08v1.49l7.84 3.267a.188.188 0 01.002.345l-8.91 3.819a2.998 2.998 0 01-2.364 0l-8.91-3.82a.187.187 0 01.002-.344l7.84-3.267-.02-1.482-9.502 4.072a.375.375 0 00-.228.345z"}})])
          )
        }
      }
    